import { DefaultPickService, EmptyContext2d } from "@visactor/vrender-core";

export class DefaultMathPickerService extends DefaultPickService {
    constructor(contributions, pickItemInterceptorContributions, pickServiceInterceptorContributions) {
        super(pickItemInterceptorContributions, pickServiceInterceptorContributions), this.contributions = contributions, 
        this.pickItemInterceptorContributions = pickItemInterceptorContributions, this.pickServiceInterceptorContributions = pickServiceInterceptorContributions, 
        this.global.hooks.onSetEnv.tap("math-picker-service", ((lastEnv, env, global) => {
            this.configure(global, env);
        })), this.configure(this.global, this.global.env), this.pickerMap = new Map, this.init();
    }
    init() {
        this.contributions.getContributions().forEach((item => {
            this.pickerMap.set(item.numberType, item);
        })), super._init();
    }
    configure(global, env) {
        this.pickContext = new EmptyContext2d(null, 1);
    }
    pickItem(graphic, point, parentMatrix, params) {
        if (!1 === graphic.attribute.pickable) return null;
        const picker = this.pickerMap.get(graphic.numberType);
        if (!picker) return null;
        const pd = picker.contains(graphic, point, params), g = pd ? graphic : null;
        return g ? {
            graphic: g,
            params: pd
        } : null;
    }
}
//# sourceMappingURL=math-picker-service.js.map